/* eslint-disable camelcase */
import b12sahkobussit1 from './b12sahkobussit1.png'
import b12sahkobussit2 from './b12sahkobussit2.png'
import b20robottibusseja1 from './b20robottibusseja1.png'
import b20sahkoautoja1 from './b20sahkoautoja1.png'
import b20yhteiskayttoautoja1 from './b20yhteiskayttoautoja1.png'
import b30sahkoautoja2 from './b30sahkoautoja2.png'
import r10metaani_talteenotto1 from './r10metaani_talteenotto1.png'
import r12biokaasua_biojatteesta1 from './r12biokaasua_biojatteesta1.png'

import r12biokaasua_biojatteesta2 from './r12biokaasua_biojatteesta2.png'
import r13kaukolammon_ohjaus1 from './r13kaukolammon_ohjaus1.png'
import r13kaukolammon_ohjaus2 from './r13kaukolammon_ohjaus2.png'
import r20metaani_talteenotto1 from './r20metaani_talteenotto1.png'
import r20metaani_talteenotto2 from './r20metaani_talteenotto2.png'
import r30paastotonta_sahkoa_kysyntajousto1 from './r30paastotonta_sahkoa_kysyntajousto1.png'
import r30paastotonta_sahkoa_kysyntajousto2 from './r30paastotonta_sahkoa_kysyntajousto2.png'
import y10aurinko_pientaloihin2 from './y10aurinko_pientaloihin2.png'

import y11maalampo_pientaloihin1 from './y11maalampo_pientaloihin1.png'
import y12aurinko_kerrostaloihin1 from './y12aurinko_kerrostaloihin1.png'
import y12maalampo_aurinko_kouluihin1 from './y12maalampo_aurinko_kouluihin1.png'
import y20aurinko_pientaloihin1 from './y20aurinko_pientaloihin1.png'
import y20hoivarakennus_nollaenergia1 from './y20hoivarakennus_nollaenergia1.png'
import y21kaukolampo_datakeskuksesta1 from './y21kaukolampo_datakeskuksesta1.png'
import y22maalampo_pientaloihin1 from './y22maalampo_pientaloihin1.png'
import y22maalampo_pientaloihin2 from './y22maalampo_pientaloihin2.png'

export const cards = [
  { src: b12sahkobussit1, color: 'b', co2: 1, cash: 2, id: 'sahkobussit' },
  { src: b12sahkobussit2, color: 'b', co2: 1, cash: 2, id: 'sahkobussit' },
  { src: b20robottibusseja1, color: 'b', co2: 2, cash: 0, id: 'robottibusseja' },
  { src: b20sahkoautoja1, color: 'b', co2: 2, cash: 0, id: 'sahkoautoja' },
  { src: b20yhteiskayttoautoja1, color: 'b', co2: 2, cash: 0, id: 'yhteiskayttoautoja' },
  { src: b30sahkoautoja2, color: 'b', co2: 3, cash: 0, id: 'sahkoautoja' },
  { src: r10metaani_talteenotto1, color: 'r', co2: 1, cash: 0, id: 'metaani_talteenotto' },
  { src: r12biokaasua_biojatteesta1, color: 'r', co2: 1, cash: 2, id: 'biokaasua_biojatteesta' },

  { src: r12biokaasua_biojatteesta2, color: 'r', co2: 1, cash: 2, id: 'biokaasua_biojatteesta' },
  { src: r13kaukolammon_ohjaus1, color: 'r', co2: 1, cash: 3, id: 'kaukolammon_ohjaus' },
  { src: r13kaukolammon_ohjaus2, color: 'r', co2: 1, cash: 3, id: 'kaukolammon_ohjaus' },
  { src: r20metaani_talteenotto1, color: 'r', co2: 2, cash: 0, id: 'metaani_talteenotto' },
  { src: r20metaani_talteenotto2, color: 'r', co2: 2, cash: 0, id: 'metaani_talteenotto' },
  { src: r30paastotonta_sahkoa_kysyntajousto1, color: 'r', co2: 3, cash: 0, id: 'paastotonta_sahkoa_kysyntajousto' },
  { src: r30paastotonta_sahkoa_kysyntajousto2, color: 'r', co2: 3, cash: 0, id: 'paastotonta_sahkoa_kysyntajousto' },
  { src: y10aurinko_pientaloihin2, color: 'y', co2: 1, cash: 0, id: 'aurinko_pientaloihin' },

  { src: y11maalampo_pientaloihin1, color: 'y', co2: 1, cash: 1, id: 'maalampo_pientaloihin' },
  { src: y12aurinko_kerrostaloihin1, color: 'y', co2: 1, cash: 2, id: 'aurinko_kerrostaloihin' },
  { src: y12maalampo_aurinko_kouluihin1, color: 'y', co2: 1, cash: 2, id: 'maalampo_aurinko_kouluihin' },
  { src: y20aurinko_pientaloihin1, color: 'y', co2: 2, cash: 0, id: 'aurinko_pientaloihin' },
  { src: y20hoivarakennus_nollaenergia1, color: 'y', co2: 2, cash: 0, id: 'hoivarakennus_nollaenergia' },
  { src: y21kaukolampo_datakeskuksesta1, color: 'y', co2: 2, cash: 1, id: 'kaukolampo_datakeskuksesta' },
  { src: y22maalampo_pientaloihin1, color: 'y', co2: 2, cash: 2, id: 'maalampo_pientaloihin' },
  { src: y22maalampo_pientaloihin2, color: 'y', co2: 2, cash: 2, id: 'maalampo_pientaloihin' }
]
